import * as React from "react";
const SvgStopOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M16 8v8H8V8h8m2-2H6v12h12V6z" />
  </svg>
);
export default SvgStopOutlined;
